<template>
  <span v-if="tier" class="tier-badge d-inline-flex align-items-center flex-wrap">
    <b-badge :variant="badgeVariant" pill class="tier-badge__name">
      <i class="fas fa-crown mr-1" aria-hidden="true"></i>{{ tier.name }}
    </b-badge>
    <!--
      GRACE is NOT "expired" or "at risk" — the patient still holds this tier
      and its discount right now (see the header comment in
      PatientTierPanel.vue for the full grace-period explanation). A
      red/yellow badge or an "หมดอายุ"-style word here would tell staff the
      opposite of the truth, and the wrong thing then gets told to the
      patient at the till. So: same badge shape as ACTIVE, an "info" (blue,
      neutral-informative) variant rather than warning/danger, and the exact
      end date spelled out inline rather than left to a hover-only tooltip
      that's easy to miss at a counter.
    -->
    <small v-if="isGrace" class="tier-badge__grace text-info ml-1">
      ช่วงต่อสิทธิ์<span v-if="graceUntilLabel"> · สิทธิ์ยังคงมีผลถึง {{ graceUntilLabel }}</span>
    </small>
  </span>
</template>

<script>
import moment from "moment";

export default {
  name: "TierBadge",
  props: {
    // The patient's current tier, e.g. { id, name, rank, thresholdAmount }.
    // null/undefined = patient has no tier yet -> render nothing (callers
    // should not have to know this rule; enforced here).
    tier: { type: Object, default: null },
    // "ACTIVE" | "GRACE" (patient_tier_state.status).
    status: { type: String, default: "" },
    graceUntilDt: { type: [String, Date], default: null },
  },
  computed: {
    isGrace() {
      return this.status === "GRACE";
    },
    badgeVariant() {
      return this.isGrace ? "info" : "success";
    },
    // DD/MM/YYYY (Gregorian, numeric) rather than moment's "th" locale
    // formatting used elsewhere in this codebase (see formatDate.js): the
    // "th" locale prints Thai month names but leaves the YEAR as plain
    // Gregorian, which reads to staff like a Buddhist-Era year and is wrong
    // most years. A grace end date is exactly the kind of date where staff
    // misreading the year matters, so this uses the same unambiguous
    // numeric format VoucherBatchReport.vue's fmtDate already established.
    graceUntilLabel() {
      return this.graceUntilDt ? moment(this.graceUntilDt).format("DD/MM/YYYY") : "";
    },
  },
};
</script>

<style scoped>
.tier-badge__grace {
  white-space: normal;
}
</style>
